module.exports = __webpack_public_path__ + "static/media/Blue.b192e193.png";